/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {DigAppOptions as ɵb} from './lib/interfaces/dig-app-options';
export {AppModel as ɵa} from './lib/models/app-model';